var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"iframeGameContainer",staticClass:"iframe-game-container",class:_vm.getGameName()},[(!_vm.isLoaded)?_c('loading-spinner'):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3578a810","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/iframe-game/iframe-game.html
// module id = null
// module chunks = 